<a [ngClass]="{'left': infoData.whatsapp.position.position == 'left','right': infoData.whatsapp.position.position == 'right'}"
    href="https://api.whatsapp.com/send?phone={{whatsAppNumber}}{{whatsAppMessage ? '&text='+ whatsAppMessage: ''}}"
    target="_blank"
    class="btn-whats-app"
    (click)="triggerWhatsAppEvent()">
    <i class="icon-whatsapp notranslate"></i>
</a>

